import React from 'react';
import { Result } from 'antd';
import { IRouteComponentProps } from '@mjcloud/router-helper';

const LoginPage: React.FC<IRouteComponentProps> = () => {
  return <Result status="403" title="403" subTitle="抱歉，暂不支持在当前容器登录" />;
};

export default LoginPage;
